import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tbox-sizing: border-box;\n\topacity: 0;\n\toutline: none;\n\tposition: relative;\n\ttransform-origin: center center;\n\ttransition: opacity ", " linear;\n\twidth: 100%;\n\n\t&[data-enter] {\n\t\topacity: 1;\n\t}\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, ui } from '@wp-g2/styles';
export var PopoverContent = css(_templateObject(), ui.zIndex('Popover'), ui.get('transitionDurationFastest'));